import { t } from '@lingui/core/macro';

import getBrandSpecificValue from '@rover/shared/js/utils/getBrandSpecificValue';

const HEADER_TEXT = (isCompulsory: boolean): string =>
  getBrandSpecificValue({
    rover: isCompulsory
      ? t`Verify your email to set up your Rover account`
      : t`Verify your email to secure your account`,
    catInAFlat: isCompulsory
      ? t`Verify your email to set up your account`
      : t`Verify your email to secure your account`,
  });

const IMAGE_HEADER_CONTENT = (userEmail: string, isCompulsory: boolean): string =>
  getBrandSpecificValue({
    rover: isCompulsory
      ? t`Enter the verification code Rover sent to ${userEmail}. Check your spam folder if you don't see it. You will not be able to book with Rover until you complete this step.`
      : t`We just sent a verification code to ${userEmail}. Check your spam folder if you don't see it in your inbox`,
    catInAFlat: isCompulsory
      ? t`Enter the verification code sent to ${userEmail}. Check your spam folder if you don't see it. You will not be able to book until you complete this step.`
      : t`We just sent a verification code to ${userEmail}. Check your spam folder if you don't see it in your inbox`,
  });

export { HEADER_TEXT, IMAGE_HEADER_CONTENT };
